import { useNavigate } from 'react-router-dom'

import { useModalContext } from '@fourthwall/components'

import { useDashboardFeatureFlags } from '../../../../../../../../../components/utils/DashboardFeatureFlags'
import { reverse, routing } from '../../../../../../../../../utils/routing'
import { useCurrentShopContext } from '../../../../../../../hooks/useCurrentShopContext'
import { usePages } from '../../../../../../../hooks/usePages'
import { useThemeEditorContext } from '../../../../../../../hooks/useThemeEditorContext'
import { useDraftContext } from '../../../../../../../providers/DraftProvider'
import { usePageLayoutContext } from '../../../../../../../providers/PageLayoutProvider'
import { useThemeLivePreviewContext } from '../../../../../../LivePreview/providers/ThemeLivePreviewProvider'
import { useCreateSectionMutation } from '../../../../../hooks/useCreateSectionMutation'

export const useSection = () => {
  const { currentShop } = useCurrentShopContext()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const navigate = useNavigate()
  const { setIsPreviewLoading, resetPreviewTimestamp, currentPageId } = useThemeEditorContext()
  const { createSectionMutation } = useCreateSectionMutation()
  const { pageLayoutQuery } = usePageLayoutContext()
  const { currentPage } = usePages()
  const { close } = useModalContext()
  const { channel } = useThemeLivePreviewContext()
  const { draftId } = useDraftContext()

  const createLayoutSection = (
    sectionType: string,
    blockId: string,
    position?: number,
    platformAppId?: string,
  ) => {
    !dashboardFeatureFlags.themeEditorDynamicPreview.enabled && setIsPreviewLoading(true)

    createSectionMutation.mutate(
      [
        {
          shop_id: currentShop.id,
        },
        {
          draft_theme_id: draftId,
          shop_page_id: blockId !== 'content_for_index' ? undefined : currentPageId,
          section_type: sectionType,
          platform_section: blockId,
          position,
          platform_app_id: platformAppId,
        },
      ],
      {
        onSuccess: async ({ sectionKey }) => {
          if (dashboardFeatureFlags.themeEditorDynamicPreview.enabled) {
            const response = await fetch(currentPage?.url!)
            const htmlText = await response.text()

            const parser = new DOMParser()
            const doc = parser.parseFromString(htmlText, 'text/html')
            const bodyContent = doc.body.outerHTML

            channel.emit({
              action: 'ThemePreview:UpdateDOM',
              payload: {
                content: bodyContent,
              },
            })
          }

          pageLayoutQuery.refetch()
          !dashboardFeatureFlags.themeEditorDynamicPreview.enabled && resetPreviewTimestamp()
          close()
          navigate(
            reverse(routing.themeEditorV2.layout.page.sections, {
              pageId: currentPageId,
              sectionKey,
            }),
          )
        },
      },
    )
  }

  return {
    isLoading: createSectionMutation.isLoading,
    createLayoutSection,
  }
}
